/**
 * Which context-menu actions have a working SDK method.
 *
 * NOTE: Defaults to `false`, unlike the server-driven `featureStateData` license
 * flags which default to `true`. A `false` entry renders disabled and must never
 * fire, however permissive those flags are. Flip one only once its SDK ships.
 */
export const CHAT_MENU_CAPABILITY = {
    archive: true,
    pin: true,
    mute: true,
    markRead: true,
    edit: true,
    lock: false,
    favorite: true,
    clear: true,
    delete: true,
    block: true,
    report: true,
    leaveGroup: true,
    // FR71 conversation pane. See Conversation/fr71PendingBackend.js for what blocks each.
    pinMessage: true,
    keepMessage: true,
    blockGroup: false,
    groupJoinRequests: false,
    searchInChat: false,
    exportChat: false,
    chatSettings: false,
};

export const CHAT_MENU_ACTION = {
    ARCHIVE: 'archive',
    PIN: 'pin',
    MUTE: 'mute',
    MARK_READ: 'markRead',
    EDIT: 'edit',
    LOCK: 'lock',
    FAVORITE: 'favorite',
    CLEAR: 'clear',
    DELETE: 'delete',
    BLOCK: 'block',
    REPORT: 'report',
    LEAVE_GROUP: 'leaveGroup',
    PIN_MESSAGE: 'pinMessage',
    SEARCH_IN_CHAT: 'searchInChat',
    EXPORT_CHAT: 'exportChat',
    CHAT_SETTINGS: 'chatSettings',
};

export const isChatMenuActionAvailable = action => CHAT_MENU_CAPABILITY[action] === true;
